import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FaSave } from 'react-icons/fa';
import InternalHeader from '../InternalHeader';
import Sidebar from '../Sidebar';
import '../Patients/CreatePatient.css'; // Assuming you're using the same CSS
import AccessControl from '../AccessControl';
import LinkMap from '../LinkMap/LinkMap';

const StoresDetails = () => {
    const { id } = useParams(); // Get the stores item ID from the URL
    const [storesItem, setStoresItem] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isSidebarVisible, setIsSidebarVisible] = useState(true);
    const [isEditable, setIsEditable] = useState(false);
    const [successModalVisible, setSuccessModalVisible] = useState(false);
    const linkData = [
        { label: 'Suppliers', path: '/suppliers' },
        { label: 'Inventory Details', path: '/store-details' },
    ];

    // Fetch stores item data based on ID
    useEffect(() => {
        const fetchStoresItem = async () => {
            try {
                const response = await fetch(`https://api.hgcdental.clinic/api/stores/${id}`);
                if (!response.ok) throw new Error('Failed to fetch stores item');
                const data = await response.json();
                setStoresItem(data);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };
        fetchStoresItem();
    }, [id]);

    const handleSaveClick = async () => {
        try {
            const response = await fetch(`https://api.hgcdental.clinic/api/stores/${id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(storesItem),
            });

            if (!response.ok) throw new Error('Failed to update stores item');
            const updatedItem = await response.json();
            setStoresItem(updatedItem);
            setIsEditable(false);
            setSuccessModalVisible(true);
        } catch (error) {
            console.error(error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setStoresItem((prev) => ({ ...prev, [name]: value }));
    };

    const toggleSidebar = () => setIsSidebarVisible(!isSidebarVisible);
    const handleEditClick = () => setIsEditable(true);
    const closeSuccessModal = () => setSuccessModalVisible(false);

    if (loading) return <div>Loading...</div>;
    if (!storesItem) return <div>No stores item found</div>;

    return (
        <AccessControl>
            <div className={`create-patient-container ${isSidebarVisible ? 'sidebar-visible' : 'sidebar-hidden'}`}>
                <InternalHeader moduleName="Store" toggleSidebar={toggleSidebar} />
                <div className="create-patient-content">
                    <Sidebar isSidebarVisible={isSidebarVisible} />
                    <div className="create-patient">
                        <LinkMap
                            links={linkData}
                            moduleName="Stores"
                            moduleIcon="inventory"
                        />
                        <div>
                            {isEditable ? (
                                <button className="create-patient-button" onClick={handleSaveClick}>
                                    <FaSave /> Save
                                </button>
                            ) : (
                                <button className="create-patient-button" onClick={handleEditClick}>Edit</button>
                            )}
                        </div>
                        <div className="create-patient-form">
                            <h2>Store Details</h2>
                            {/* Store Name Field */}
                            <div className="input-group">
                                <label className="label">Store Name</label>
                                <input
                                    type="text"
                                    name="StoreName"
                                    value={storesItem.StoreName || ''}
                                    onChange={handleInputChange}
                                    className="input-field"
                                    disabled={!isEditable}
                                    required
                                />
                            </div>

                            {/* Store Contact Field */}
                            <div className="input-group">
                                <label className="label">Store Contact</label>
                                <input
                                    type="text"
                                    name="StoreContact"
                                    value={storesItem.StoreContact || ''}
                                    onChange={handleInputChange}
                                    className="input-field"
                                    disabled={!isEditable}
                                    required
                                />
                            </div>

                            {/* Name Field */}
                            <div className="input-group">
                                <label className="label">Store Address</label>
                                <input
                                    type="text"
                                    name="Address"
                                    value={storesItem.StoreAddress || ''}
                                    onChange={handleInputChange}
                                    className="input-field"
                                    disabled={!isEditable}
                                    required
                                />
                            </div>

                        </div>

                        {/* Success Modal */}
                        {successModalVisible && (
                            <div className="modal-overlay" onClick={closeSuccessModal}>
                                <div className="modal success-modal" onClick={(e) => e.stopPropagation()}>
                                    <h3>Success!</h3>
                                    <div className="modal-divider" />
                                    <p>Stores item updated successfully.</p>
                                    <div className="modal-divider" />
                                    <button className="confirm-button" onClick={closeSuccessModal}>Close</button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </AccessControl>
    );
};

export default StoresDetails;